export function validateSupplierGroupName(groupName: string) {
  const specialChars = /^[-@_\w\s]{0,28}$/;
  const isValidGroupName = specialChars.test(groupName);
  return isValidGroupName;
}
